import { MainOuterCard } from "../../../shared/styles";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

interface IStyleProps {
  up?: boolean;
  down?: boolean;
  bgColor?: string;
  active?: boolean;
  horizontal?: boolean;
  fontSize?: string;
}

export const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  /* overflow-y: auto; */
  /* padding-right: 30px; */

  &::-webkit-scrollbar {
    width: 0.7em;
    height: 0.4em;
    background-color: #15283717;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }

  > div > ${FlexContainer} {
    gap: 20px;
    ${MainOuterCard} {
      width: 100%;
      height: 100%;
      padding: 20px;
    }
  }
  .activity-card-header {
    color: #2c3e50;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
  }
  .activity-header-wrapper {
    button {
      width: 55px;
      min-width: 55px;
      height: 25px;
      padding: 5px;
    }
    .single-select-wrapper {
      width: auto;
      min-width: 100px;
      cursor: pointer;
      .header {
        border: none;
        width: auto;
        min-width: 100px;
      }
      .select-header-icon {
        border-left: none;
      }
    }
    .gross-revenue-dropdown {
      .options-menu {
        width: 150px;
        border-radius: 4px;
        transform: translate(10px, 37px);
      }
      .select-header-icon {
        transform: translate(-18px, 2px);
      }
    }
    &.flex-unset {
      flex: unset !important;
    }
  }
  .recent-customer-table {
    border: none;
    thead th:first-child,
    tbody tr td:first-child {
      padding-left: 0px !important;
      /* Show the full Date value (it includes the time, so the default 160px
         truncates it) and add generous breathing room before the Contact
         column so the two don't sit flush against each other. */
      width: auto;
      min-width: 200px;
      white-space: nowrap;
      overflow: visible;
      text-overflow: clip;
      padding-right: 60px;
    }
    tbody {
      height: 255px;
    }
    .recent-amount-column {
      width: 250px;
      overflow: visible;
      /* The amount + payment-method icon must never be clipped. Reserve enough
         room for up to 6 digits ($999,999.99) plus the ~19px icon, and let the
         value size to its content instead of being squeezed by a large fixed
         right padding. */
      ${FlexContainer} {
        padding-right: 20px;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: nowrap;
        white-space: nowrap;
        width: 100%;
      }
    }
    .recent-status-btn {
      min-width: 85px;
      max-width: 140px;
      width: auto;
    }
    .recent-amount-header {
      width: 250px;
      padding-left: 25px;
      padding-right: 40px;
      text-align: right;
    }
    &.db-payment-plh {
      .plh-main-icon {
        height: 80px;
        width: 80px;
        margin-top: 20px;
      }
      .plh-label {
        font-size: 24px !important;
        margin: 20px 0px !important;
      }
      .plh-description {
        font-size: 14px;
        line-height: 20px;
      }
    }
    &.db-payment-plh .plh-main-section {
      border: none;
    }
  }
  .graph-sub-header {
    ${CustomLabel} {
      color: #2c3e50;
      &:first-child {
        font-size: 14px;
        line-height: 24px;
      }
      &:last-child {
        font-size: 30px;
        line-height: 34px;
        font-weight: 600;
      }
    }
  }
  .revenue-sub-headers {
    padding: 0px 0px 25px;
    align-items: center;
    justify-content: space-between;
    width: 65%;
    > div > ${FlexContainer} {
      flex-direction: column;
      gap: 15px;
      div ${CustomLabel}:not(.dpdn-overlay) {
        font-size: 14px;
        line-height: 24px;
        font-weight: 600;
        color: #aaa;
      }
    }
    ${CustomLabel}:not(:last-child,.dpdn-overlay) {
      font-size: 30px;
      line-height: 36px;
      font-weight: 600;
      color: #2c3e50;
    }
  }
  .subscriptions-graph {
    width: 85%;
    margin: 0 auto;
  }
  .activity-graph-body {
    width: 95.5%;
    margin: 0 auto;
    height: 100%;
  }
  .breakdown-label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 180px;
  }
  .breakdown-caption {
    display: block;
    padding-top: 20px;
    color: #7f8c8d;
    font-size: 12px;
    line-height: 16px;
  }
  /* Original (Fiserv) Recent Activity layout: three equal columns with the
     metric pushed to the right edge of its column. */
  .activity-widget-classic {
    .recent-activity-block {
      padding-right: calc(100% - 180px);
      .sensex-box-wrapper {
        text-align: left;
        width: 65px;
        flex-shrink: 0;

        i.fa.fa-solid.fa-sort-down {
          position: relative;
          bottom: 4px;
          margin-bottom: 0;
        }
        i.fa.fa-solid.fa-sort-up {
          position: relative;
          top: 4px;
          margin-top: 0;
        }
      }
      .sensex-value-wrapper {
        width: 150px;
        text-align: right;
      }
    }
    @media (max-width: 1550px) {
      .recent-activity-block {
        padding-right: 15%;
      }
    }
    @media (min-width: 2100px) and (max-width: 3000px) {
      .recent-activity-block {
        padding-right: 30%;
      }
    }
    @media (min-width: 3001px) {
      .recent-activity-block {
        padding-right: 40%;
      }
    }
  }
  /* Expanded (NMI) Recent Activity layout: wide card sitting next to the
     Subscription Breakdown widget, with its own Today / This Month header. */
  .activity-widget-expanded {
    .recent-activity-row {
      width: 100%;
      .ra-label,
      .ra-metric {
        flex: 1 1 0;
        min-width: 0;
      }
      .ra-label label {
        white-space: nowrap;
      }
      .ra-metric {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
    .recent-activity-block {
      .sensex-box-wrapper {
        text-align: left;
        width: 60px;
        flex-shrink: 0;

        i.fa.fa-solid.fa-sort-down {
          position: relative;
          bottom: 4px;
          margin-bottom: 0;
        }
        i.fa.fa-solid.fa-sort-up {
          position: relative;
          top: 4px;
          margin-top: 0;
        }
      }
      .sensex-value-wrapper {
        flex: 0 0 140px;
        width: 140px;
        min-width: 140px;
        max-width: 140px;
        text-align: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    /* Header cells: center the label over the full value + badge group
       (140px value + 8px gap + 60px badge = 208px) so the header shares
       the same center line as the values and percentage badges below it. */
    .recent-activity-block.recent-activity-header {
      .sensex-value-wrapper {
        flex: 0 0 208px;
        width: 208px;
        min-width: 208px;
        max-width: 208px;
        text-align: center;
        /* nudge the header label 30px to the right */
        transform: translateX(40px);
      }
      .sensex-box-wrapper {
        display: none;
      }
    }
  }
  .prior-option-dpdn {
    margin-bottom: 8px;
    color: rgba(39, 62, 82, 1);
    cursor: pointer;
  }
  ${FlexContainer}.db-min-width {
    min-width: 1300px;
  }
  ${FlexContainer}.equal-height-row {
    align-items: stretch;
    ${MainOuterCard} {
      height: auto;
      align-self: stretch;
    }
  }
  .empty-centered-navpill {
    min-width: 120px;
  }
  &.funding-summary-wrapper {
    .funding-half-section {
      width: 48%;
      min-width: 48%;
      max-width: 48%;
      &:nth-child(odd) {
        .funding-custom-line {
          display: none;
        }
      }
    }
    .main-card-min-width {
      padding: 30px 0px 30px 25px !important;
    }
    .activity-card-sub-header {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }
    .payout-category {
      margin-left: 33px;
      .payouts-list {
        margin-left: 35px;
      }
    }
    .payout-status {
      width: 120px;
      .payout-status-btn {
        min-width: 90px;
        width: 90px;
        height: 24px;
        padding: 0px;
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        border-radius: 4px;
      }
    }
    .payout-details {
      width: 180px;
      padding-right: 30px;
      text-align: right;
      label {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        cursor: pointer;
      }
      &:hover {
        label {
          text-decoration: underline;
          color: #556bb8;
        }
      }
    }
    .payout-date {
      width: 120px;
      label {
        font-size: 14px;
        color: #555;
        font-weight: 400;
        line-height: 24px;
      }
    }
    .payout-item {
      margin: 10px 0px 0px;
      &:hover {
        cursor: pointer;
      }
    }
    .payout-merchant-account {
      min-width: 315px;
      width: auto;
      label {
        font-size: 14px;
        color: #555;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .accounts-container {
      padding-left: 70px;
      gap: 60px 30px;
    }
    .funding-smaller-grids {
      width: 750px;
    }
    .payout-sub-header-icon {
      height: 20px;
      width: 20px;
    }
    .funding-address {
      label {
        font-size: 14px;
        line-height: 18px;
      }
    }
    .funding-accounts-logo {
      height: 35px;
      width: 120px;
      object-fit: contain;
    }
    .funding-payouts-grid {
      table {
        border: none;
        th {
          color: #555;
        }
        td {
          border-bottom: none;
        }
        tbody {
          /* height: calc(100vh - 520px); // creating issue in staging */
          height: calc(100vh - 402px); // creating issue in staging
        }
      }
      .table-pagination {
        border: none;
      }
      &.funding-payout-plh {
        tbody {
          height: calc(100vh - 353px);
        }
        .plh-main-section {
          border: none;
        }
      }
    }
    .funding-inherit-height {
      min-height: inherit;
      /* height: inherit; */
    }
    .funding-summary-block {
      flex: unset;
      overflow-y: auto;
      height: calc(100vh - 273px);
      padding-right: 0px;
      &::-webkit-scrollbar {
        width: 0.7em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid #ddd;
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
      &.funding-summary-plh {
        /* height: calc(100vh - 390px); */ // creating issue for payout plh
      }
      .tsys-logo {
        width: 80px;
      }
      .elavon-logo {
      }
      .global-collect-logo {
      }
      .fiserv-logo {
        height: auto;
      }
      .mindme-logo {
      }
    }
    .funding-payout-block {
      padding-right: 30px;
    }
    /* funding placeholder UI */
    .funding-plh-wrapper {
      .plh-main-section {
        border: none;
      }
      .plh-description {
        padding: 0.5rem;
      }
    }
    .funding-full-height {
      height: 100%;
    }
  }
`;
export const ThreeColumns = styled.div`
  width: 33.33%;
`;
export const SensexBox = styled.div<IStyleProps>`
  min-width: 30px;
  width: auto;
  /* width: 70px; */
  height: 20px;
  font-size: ${(props) => props.fontSize || "13px"};
  font-weight: 600;
  line-height: 18px;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.up
      ? "rgba(87, 172, 45, 0.1)"
      : props.down
        ? "rgba(255, 75, 85, 0.1)"
        : "rgba(119, 119, 119, 0.1)"};
  color: ${(props) =>
    props.up
      ? "rgba(87, 172, 45)"
      : props.down
        ? "rgba(255, 75, 85)"
        : "rgba(119, 119, 119)"};
  .fa.fa-solid {
    line-height: 8px;
    font-size: 16px;
    margin-right: 4px;
    color: ${(props) =>
      props.up
        ? "rgba(87, 172, 45)"
        : props.down
          ? "rgba(255, 75, 85)"
          : "rgba(119, 119, 119)"};

    &.fa-sort-down {
      margin-bottom: 4px;
    }
    &.fa-sort-up {
      margin-top: 8px;
    }
  }
`;
export const RespresentativeBox = styled.div<IStyleProps>`
  width: ${(props) => (props.horizontal ? "19px" : "12px")};
  height: ${(props) => (props.horizontal ? "12px" : "19px")};
  background-color: ${(props) => props.bgColor || "#C9D5FC"};
`;
export const FilterTimePeriod = styled.div<IStyleProps>`
  width: auto;
  padding: 6px 8px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  background-color: ${(props) => (props.active ? "#556BB8" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#556BB8")};
  cursor: pointer;
`;
export const AcitivityGraphToolTip = styled.div<IStyleProps>`
  min-width: 120px;
  min-height: 50px;
  padding: 12px 8px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  text-align: center;
  background-color: ${(props) => props.bgColor};
  color: #fff !important;
  cursor: pointer;
`;
